import { render } from "./SucaiFiles.vue?vue&type=template&id=bf590c66&scoped=true"
import script from "./SucaiFiles.vue?vue&type=script&lang=js"
export * from "./SucaiFiles.vue?vue&type=script&lang=js"

import "./SucaiFiles.vue?vue&type=style&index=0&id=bf590c66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf590c66"]])

export default __exports__